import kitchenSlim from '../images/kitchen-slim.png';
import photoOne from '../images/home-image-one.jpeg';
import photoTwo from '../images/home-image-two.jpeg';
import photoThree from '../images/home-image-three.jpg';
import photoFour from '../images/home-image-four.jpeg';

// First image is highlighted
export const IMAGES = [kitchenSlim, photoOne, photoTwo, photoThree, photoFour];
